module.exports = __webpack_public_path__ + "img/play.8ef72fe.svg";